// This file manages exports from the base atom, molecule, or organism.
// Use named rather than default exports.
import { EditableComponent } from '@adobe/aem-react-editable-components';
import dynamic from 'next/dynamic';
import type { LoyaltyWidgetContainerProps } from './LoyaltyWidgetContainer.types';

export const LoyaltyWidgetContainer = dynamic(() =>
  import('./LoyaltyWidgetContainer').then(mod => mod.LoyaltyWidgetContainer)
);

export const LoyaltyWidgetContainerConfig = {
  emptyLabel: 'Loyalty Widget Container',
  resourceType: ``,
  isEmpty: () => true,
};

export const LoyaltyWidgetContainerEditable = (props: LoyaltyWidgetContainerProps) => {
  return (
    <EditableComponent config={LoyaltyWidgetContainerConfig} {...props}>
      <LoyaltyWidgetContainer {...props} />
    </EditableComponent>
  );
};

export type { LoyaltyWidgetContainerProps } from './LoyaltyWidgetContainer.types';
export {
  LoyaltyWidgetContainerContext,
  useLoyaltyWidgetBadgePublisher,
  buildContainerCountBadgeText,
} from './LoyaltyWidgetContainerContext';
export type { LoyaltyWidgetContainerContextValue } from './LoyaltyWidgetContainerContext';
